export type BannerSeverity = 'info' | 'warning' | 'critical';

export const BANNER_SEVERITIES: BannerSeverity[] = ['info', 'warning', 'critical'];

export const BANNER_SEVERITY_LABELS: Record<BannerSeverity, string> = {
  info: 'Информация',
  warning: 'Предупреждение',
  critical: 'Критическое',
};

export type PublicBanner = {
  id: string;
  title: string;
  body: string;
  severity: BannerSeverity;
  startsAt: string;
  endsAt: string;
};

export type AdminBanner = PublicBanner & {
  isActive: boolean;
  createdBy?: string | { id?: string; username?: string } | null;
  createdAt?: string;
  updatedAt?: string;
};

export type BannerSocketPayload = {
  banner: PublicBanner | null;
  source?: string;
};

export type CreateBannerPayload = {
  title: string;
  body: string;
  severity?: BannerSeverity;
  startsAt: string;
  endsAt: string;
  isActive?: boolean;
};

export type UpdateBannerPayload = Partial<CreateBannerPayload>;

export function isBannerLive(banner: PublicBanner, now = Date.now()): boolean {
  const starts = Date.parse(banner.startsAt);
  const ends = Date.parse(banner.endsAt);
  if (Number.isNaN(starts) || Number.isNaN(ends)) return false;
  return starts <= now && now < ends;
}

export function bannerDismissStorageKey(id: string): string {
  return `banner:dismissed:${id}`;
}

export function isBannerDismissed(id: string): boolean {
  try {
    return sessionStorage.getItem(bannerDismissStorageKey(id)) === '1';
  } catch {
    return false;
  }
}

export function markBannerDismissed(id: string): void {
  try {
    sessionStorage.setItem(bannerDismissStorageKey(id), '1');
  } catch {
    /* private mode / quota */
  }
}
